/**
 * Created by ZengFanhui on 2021/1/4 11:37
 */
import http from '../utils/httpRequest'

/**
 * 上传文件接口
 */
export const fileUploadUrl = http.adornUrl('/file/upload.action')
